var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "roleInfo",
      staticClass: "demo-ruleForm",
      attrs: { model: _vm.roleInfo, rules: _vm.roles }
    },
    [
      _c("div", { staticClass: "simple-form" }, [
        _vm.isAdd
          ? _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("权限来源")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "roleSrcFlag" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.roleSrcFlag,
                            callback: function($$v) {
                              _vm.roleSrcFlag = $$v
                            },
                            expression: "roleSrcFlag"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("职责权限")
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("无")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isAdd && _vm.roleSrcFlag == 1
          ? _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("职责权限")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "srcTplName" } },
                    [
                      _c("el-input", {
                        staticClass: "bottom-line width-2x",
                        attrs: { disabled: true },
                        model: {
                          value: _vm.roleInfo.srcTplName,
                          callback: function($$v) {
                            _vm.$set(_vm.roleInfo, "srcTplName", $$v)
                          },
                          expression: "roleInfo.srcTplName"
                        }
                      }),
                      _vm._v(" "),
                      _c("i", {
                        staticClass:
                          "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                        attrs: { title: "选择职责权限" },
                        on: {
                          click: function($event) {
                            _vm.tplComRoleDlg()
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [_vm._v("岗位名称")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "name" } },
                [
                  _c("el-input", {
                    staticClass: "width-2x",
                    attrs: { type: "text", "auto-complete": "off" },
                    model: {
                      value: _vm.roleInfo.name,
                      callback: function($$v) {
                        _vm.$set(_vm.roleInfo, "name", $$v)
                      },
                      expression: "roleInfo.name"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [_vm._v("岗位编码")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "code" } },
                [
                  _c("el-input", {
                    staticClass: "width-2x",
                    attrs: { type: "text", "auto-complete": "off" },
                    model: {
                      value: _vm.roleInfo.code,
                      callback: function($$v) {
                        _vm.$set(_vm.roleInfo, "code", $$v)
                      },
                      expression: "roleInfo.code"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [_vm._v("描述")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    staticClass: "width-2x",
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder: "请输入内容"
                    },
                    model: {
                      value: _vm.roleInfo.desc,
                      callback: function($$v) {
                        _vm.$set(_vm.roleInfo, "desc", $$v)
                      },
                      expression: "roleInfo.desc"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57508308", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57508308","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/authx/SaveComRole.vue
// module id = 3472
// module chunks = 0